import { Route } from 'react-router-dom';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Layout from '../components/layout';
import ProtectedRoute from '../components/ProtectedRoute';

export const DashboardRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/" element={
      <ProtectedRoute>
        <Layout activePage='dashboard' menuActive={menuActive} setMenuActive={setMenuActive}>
          <Dashboard />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
